import { render, staticRenderFns } from "./Cornerbar.vue?vue&type=template&id=9787d474"
import script from "./Cornerbar.vue?vue&type=script&lang=js"
export * from "./Cornerbar.vue?vue&type=script&lang=js"
import style0 from "./Cornerbar.vue?vue&type=style&index=0&id=9787d474&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports